// src/pages/B2B/crm/CRMPage.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAdminApiUrl } from '@/pages/Admin/shared';
import { useVenueList } from './api/crmClient';
import { VenueListFilters } from './api/types';
import { CRMSubTabs } from './components/CRMSubTabs';
import { VenueFilters } from './components/VenueFilters';
import { VenuePipelineTable } from './components/VenuePipelineTable';

function CRMPage(): React.ReactElement {
  const apiUrl = getAdminApiUrl('prod');
  const [filters, setFilters] = useState<VenueListFilters>({});
  const { data, loading, error } = useVenueList(apiUrl, filters);

  return (
    <div className="min-h-screen bg-[#0f0f1a]">
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-8">
        <div className="flex justify-between items-end mb-6">
          <div>
            <h1 className="text-3xl font-bold text-white font-display">CRM</h1>
            <p className="mt-2 text-gray-400 text-sm">Venue pipeline, contacts, and outreach tracking.</p>
          </div>
          <Link
            to="/b2b/crm/venues/new"
            className="bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold rounded-md px-4 py-2 no-underline"
          >
            + New Venue
          </Link>
        </div>

        <CRMSubTabs active="venue-pipeline" />

        <div className="mb-4">
          <VenueFilters filters={filters} onChange={setFilters} />
        </div>

        {error && (
          <div className="bg-red-900/20 border border-red-700/40 text-red-300 rounded-md p-3 text-sm mb-4">
            {error}
          </div>
        )}

        <div className="text-xs text-gray-500 mb-2">{data.count} venue{data.count === 1 ? '' : 's'}</div>
        <VenuePipelineTable rows={data.venues} loading={loading} />
      </div>
    </div>
  );
}

export default CRMPage;
